// Common
export const apiGetSystemKey = "Common/GetSystemKey"
